/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization();
    }
  }, [token, userProfile, loading]);

  useEffect(() => {
    // Handle logout in useEffect to avoid setState during render
    if (!loading && !userProfile && !token) {
      dispatch(logoutUser());
    }
  }, [userProfile, loading, token, dispatch]);

  // Show nothing while loading
  if (loading) {
    return null;
  }

  // Redirect to login if not authenticated
  // Admin users are already validated by the admin login API
  if (!userProfile || !token) {
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };

